import React from "react";
// import ReactDOM from 'react-dom';
import "./index.css";
import App from "./App/App";
import reportWebVitals from "./reportWebVitals";
import * as ReactDOMClient from "react-dom/client";
import { BrowserRouter } from "react-router-dom";

import { Provider } from "react-redux";
import { store } from "./store";
import { AbortControllerProvider } from "./hooks/useAbortController";
import ScrollToTop from "./components/ScrollToTop";
import { applyClientFlags } from "./config/featureFlags";
import { loadClientFlags } from "./config/loadClientFlags";

const container = document.getElementById("root");
const root = ReactDOMClient.createRoot(container);

const element = (
  <Provider store={store}>
    <BrowserRouter basename="">
      <ScrollToTop />
      <AbortControllerProvider>
        {/* <React.StrictMode> */}
        <App />
        {/* </React.StrictMode> */}
      </AbortControllerProvider>
    </BrowserRouter>
  </Provider>
);
// docs/specs/runtime-flags.md: the feature flags come from node before the first render (the UAT build has no
// REACT_APP_* env). loadClientFlags never rejects and gives up after 3 s; on any failure the flags stay as the build
// env set them, which is today's login. The entry file has no unit test of its own: both halves are tested
// (src/config/*.test.js) and the render is proven in the browser (spec, phase R3).
loadClientFlags().then((flags) => {
  applyClientFlags(flags);
  root.render(element);
});

// If you want to start measuring performance in your app, pass a function

// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
